import { render, staticRenderFns } from "./solutionCRM.vue?vue&type=template&id=fc5e38ee&scoped=true"
import script from "./solutionCRM.vue?vue&type=script&lang=js"
export * from "./solutionCRM.vue?vue&type=script&lang=js"
import style0 from "./solutionCRM.vue?vue&type=style&index=0&id=fc5e38ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5e38ee",
  null
  
)

export default component.exports